'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AlbumPlayPauseButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    playerAlbum: state.audioplayer.album,
    playerStatus: state.audioplayer.playerStatus
  };
}), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(AlbumPlayPauseButton, _Component);

  function AlbumPlayPauseButton() {
    (0, _classCallCheck3.default)(this, AlbumPlayPauseButton);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumPlayPauseButton.__proto__ || (0, _getPrototypeOf2.default)(AlbumPlayPauseButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumPlayPauseButton, [{
    key: 'onClick',
    value: function onClick(e) {
      this.props.onClick(e);
    }
  }, {
    key: 'getPlayPauseIconName',
    value: function getPlayPauseIconName() {
      return this.isPlayingState() ? 'icon-pause' : 'icon-play';
    }
  }, {
    key: 'isPlayingState',
    value: function isPlayingState() {
      var _props = this.props,
          playerStatus = _props.playerStatus,
          playerAlbum = _props.playerAlbum,
          album = _props.album;

      return playerStatus === _AudioPlayer2.default.status.play && playerAlbum.recipient_id === album.recipient_id;
    }
  }, {
    key: 'render',
    value: function render() {
      var playerIconClass = this.getPlayPauseIconName();

      return _react2.default.createElement(
        'div',
        { className: 'actionButton', onClick: this.onClick },
        _react2.default.createElement('i', { className: playerIconClass })
      );
    }
  }]);
  return AlbumPlayPauseButton;
}(_react.Component), _class3.propTypes = {
  album: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  playerAlbum: _propTypes2.default.object,
  playerStatus: _propTypes2.default.string
}, _class3.defaultProps = {
  album: {},
  onClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onClick'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getPlayPauseIconName', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getPlayPauseIconName'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'isPlayingState', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'isPlayingState'), _class2.prototype)), _class2)) || _class);
exports.default = AlbumPlayPauseButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumPlayPauseButton/AlbumPlayPauseButton.js
// module id = 815
// module chunks = 1